<template>
  <v-col align="center">
    <v-card width="1000">
      <router-view />
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: 'ESignatureActivation'
};
</script>
